import { WORKBAR_ACTIONS } from '../../constants.js';

export function activateWorkAction(expandedComponent){
  return {
    type : WORKBAR_ACTIONS.INSERT_WINDOW,
    componentOpen : expandedComponent
  };
}

export function removeWorkAction(idRemove){
  return {
    type : WORKBAR_ACTIONS.REMOVE_WINDOW,
    componentRemove : idRemove
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_workBar_selected.js